export default __webpack_public_path__ + "img/weeklyNews2.e3a8de3d.jpg";